import { getEvaluatedFlagEventProperties, setEvaluatedFlagEventProperties } from "./evaluated-flag-event-properties.js";
import { identifyAnonymous } from "./identify-anonymous.js";
import { getAnalyticsInstance } from "./get-analytics-instance.js";
import { page } from "./page.js";
import { track } from "./track.js";

export { getAnalyticsInstance, getEvaluatedFlagEventProperties, identifyAnonymous, page, setEvaluatedFlagEventProperties, track };